import { createContext } from 'react';
import type { Guide } from '../shared/guides';
import type { ExcursionFactsMap } from '../shared/excursions';
import type { Review } from '../shared/reviews';
import type { GiveawayPublic } from '../shared/giveaway';
import type { VisitorCounts } from '../shared/visitors';

/**
 * Database-backed content the server renders into public pages on every request and embeds as JSON,
 * so the hydrating client starts from identical data. Public components read it from context only.
 */
export type InitialData = { guides?: Guide[]; excursions?: ExcursionFactsMap; reviews?: Review[]; giveaway?: GiveawayPublic; visitors?: VisitorCounts };

export const INITIAL_DATA_ELEMENT_ID = 'initial-data';
export const InitialDataContext = createContext<InitialData>({});

/** Client side: the JSON the server embedded (non-executable, so CSP-safe). */
export function readInitialData(): InitialData {
  const element = document.getElementById(INITIAL_DATA_ELEMENT_ID);
  if (!element?.textContent) return {};
  try { return JSON.parse(element.textContent) as InitialData; } catch { return {}; }
}
